import React, { useState } from "react";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";

const EmployeesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  handleDeleteRequest,
  can_create,
  formikValues,
  options,
}) => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { t } = useTranslation();
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("employees.list_title") || "Store Employees",
            createBtnTitle:
              can_create && (t("employees.new") || "New Employee"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: t("employees.col_id") || "ID" },
              {
                accessor: "name",
                Header: t("employees.col_name") || "Name",
                sort: true,
              },
              {
                accessor: "email",
                Header: t("vendors.label_email") || "Email",
                sort: true,
              },
              {
                accessor: "phone_number",
                Header: t("employees.col_phone") || "Phone",
                sort: true,
              },
              {
                accessor: "status",
                Header: t("employees.col_status") || "Status",
              },
              {
                accessor: "Actions",
                Header: t("employees.col_actions") || "Actions",
              },
            ],
            isSearch: false,
            searchInputPlaceholder:
              t("employees.search_placeholder") || "Search...",
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList,
            headerChildren,
            details,
            openDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details),
            structure: () => structure({ id, t }),
            validationSchema: (_) => validationSchema(formikValues, id, t),
            deleteFun: deleteFun,
            title: id
              ? t("employees.edit") || "Edit Employee"
              : t("employees.new") || "New Employee",
            submitTitle: id
              ? t("employees.btn_update") || "Update"
              : t("employees.btn_add") || "Add",
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default EmployeesTemplate;
